/* Volley Glow V2 — drawers, cart, product gallery, sticky add to cart, delivery estimate. */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var moneyFormat = (window.vgTheme && window.vgTheme.moneyFormat) || '${{amount}}';

  function money(cents) {
    var value = (cents / 100).toFixed(2);
    var noDecimals = Math.round(cents / 100).toString();
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vg-lock');
  }
  function closeDrawers() {
    document.querySelectorAll('.vg-drawer.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('vg-lock');
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-vg-open]');
    if (opener) {
      e.preventDefault();
      var id = opener.getAttribute('data-vg-open');
      if (id === 'vg-cart') { refreshCart().then(function () { openDrawer(id); }); }
      else openDrawer(id);
      return;
    }
    if (e.target.closest('[data-vg-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart ---------- */
  function renderCart(cart) {
    document.querySelectorAll('[data-vg-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
    var body = document.querySelector('[data-vg-cart-body]');
    var total = document.querySelector('[data-vg-cart-total]');
    var foot = document.querySelector('[data-vg-cart-foot]');
    var notice = document.querySelector('[data-vg-cart-notice]');
    var noticeText = takeNotice();
    if (notice) { notice.textContent = noticeText || ''; notice.hidden = !noticeText; }
    if (!body) return cart;
    if (!cart.item_count) {
      body.innerHTML = '<div class="vg-cart-empty"><p>Your cart is empty.</p></div>';
      if (foot) foot.hidden = true;
      return cart;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="vg-cart-item__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      var was = item.original_line_price > item.final_line_price ? '<div class="vg-cart-item__was">' + money(item.original_line_price) + '</div>' : '';
      return '<div class="vg-cart-item">' +
        (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '<span></span>') +
        '<div><div class="vg-cart-item__title">' + escapeHtml(item.product_title) + '</div>' + variant +
        (item.properties && item.properties._vg_gift_for
          ? '<div class="vg-cart-item__gift">Free gift with your pack</div></div>'
          : '<div class="vg-qty"><button type="button" data-vg-line="' + (i + 1) + '" data-vg-qty="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-vg-line="' + (i + 1) + '" data-vg-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button></div></div>') +
        '<div class="vg-cart-item__price">' + money(item.final_line_price) + was + '</div></div>';
    }).join('');
    if (total) total.textContent = money(cart.total_price);
    return cart;
  }

  function postUpdates(updates) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  // Picking a bundle again replaces the one added earlier instead of stacking on top of it.
  function clearPreviousBundle() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (item) {
          if (item.properties && item.properties._vg_bundle) updates[item.key] = 0;
        });
        return Object.keys(updates).length ? postUpdates(updates) : cart;
      });
  }

  // A free gift only belongs in the cart while the pack that unlocked it is still there;
  // otherwise it would silently turn into a full-price item.
  // Shipping protection is only sold alongside a real product (ball or armbands): a cart
  // holding nothing but protection gets it removed, with a note saying why.
  var PROTECTION_NOTE = 'Shipping protection can only be added with a Volley Glow ball or LED armbands.';
  function isProtection(item) {
    return item.handle === 'shipping-protection' || /shipping protection/i.test(item.product_title || '');
  }
  function setNotice(text) {
    try { if (text) sessionStorage.setItem('vgCartNotice', text); else sessionStorage.removeItem('vgCartNotice'); } catch (e) {}
  }
  function takeNotice() {
    var text = null;
    try { text = sessionStorage.getItem('vgCartNotice'); sessionStorage.removeItem('vgCartNotice'); } catch (e) {}
    return text;
  }
  function dropOrphanGifts(cart) {
    var packs = {};
    cart.items.forEach(function (item) { packs[String(item.variant_id)] = true; });
    var updates = {};
    cart.items.forEach(function (item) {
      var forPack = item.properties && item.properties._vg_gift_for;
      if (forPack && !packs[String(forPack)]) updates[item.key] = 0;
    });
    var hasProduct = cart.items.some(function (item) { return !(item.key in updates) && !isProtection(item); });
    if (!hasProduct) {
      var removed = false;
      cart.items.forEach(function (item) { if (isProtection(item)) { updates[item.key] = 0; removed = true; } });
      if (removed) setNotice(PROTECTION_NOTE);
    }
    return Object.keys(updates).length ? postUpdates(updates) : Promise.resolve(cart);
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(dropOrphanGifts)
      .then(renderCart)
      .catch(function () {});
  }
  window.vgRefreshCart = refreshCart;

  // Catch gifts orphaned on the /cart page or in another tab.
  fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var before = cart.item_count;
      return dropOrphanGifts(cart).then(function (after) {
        if (after.item_count !== before && /\/cart\/?$/.test(location.pathname)) location.reload();
        else {
          renderCart(after);
          // A note left by a removal (here or before a /cart reload) opens the drawer so it is seen.
          if (document.querySelector('[data-vg-cart-notice]:not([hidden])')) openDrawer('vg-cart');
        }
      });
    })
    .catch(function () {});

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vg-line]');
    if (!btn) return;
    btn.disabled = true;
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(btn.getAttribute('data-vg-line')), quantity: Math.max(0, Number(btn.getAttribute('data-vg-qty'))) })
    }).then(function (r) { return r.json(); }).then(dropOrphanGifts).then(renderCart).catch(function () { btn.disabled = false; });
  });

  // Product forms marked data-vg-ajax add through the AJAX API and open the cart drawer.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-vg-ajax]');
    if (!form) return;
    e.preventDefault();
    var buttons = document.querySelectorAll('[data-vg-atc]');
    buttons.forEach(function (b) { b.disabled = true; });
    var bundle = form.querySelector('[data-vg-bundles]');
    if (bundle) {
      // The picker keeps the cart in sync as the shopper clicks; the button just opens the cart.
      (bundle._vgSync ? bundle._vgSync() : Promise.resolve())
        .then(function () { openDrawer('vg-cart'); })
        .finally(function () { buttons.forEach(function (b) { b.disabled = false; }); });
      return;
    }
    var request = { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) };
    fetch(root + 'cart/add.js', request)
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer('vg-cart'); })
      .catch(function (err) {
        var msg = form.querySelector('[data-vg-error]');
        if (msg) { msg.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; msg.hidden = false; }
      })
      .finally(function () { buttons.forEach(function (b) { b.disabled = false; }); });
  });

  // Apps that add to cart on their own (bundle apps) fire this; keep the count in sync.
  document.addEventListener('cart:refresh', refreshCart);
  document.addEventListener('cart:updated', refreshCart);

  /* ---------- Gallery ---------- */
  document.querySelectorAll('[data-vg-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('.vg-gallery__track');
    var slides = track ? track.children : [];
    var thumbs = gallery.parentNode.querySelectorAll('[data-vg-thumb]');
    if (!track || !slides.length) return;
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function sync() {
      var i = current();
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        if (n === i && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      });
    }
    var timer;
    track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(sync, 60); }, { passive: true });
    gallery.querySelectorAll('[data-vg-prev]').forEach(function (b) { b.addEventListener('click', function () { go(current() - 1); }); });
    gallery.querySelectorAll('[data-vg-next]').forEach(function (b) { b.addEventListener('click', function () { go(current() + 1); }); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
  });

  /* ---------- Quantity stepper on the product form ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-vg-step]');
    if (!step) return;
    var input = step.parentNode.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-vg-step')));
  });

  /* ---------- Variant select keeps the hidden id + price in sync ---------- */
  document.querySelectorAll('[data-vg-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var section = select.closest('[data-vg-product]');
      if (!section) return;
      var price = section.querySelector('[data-vg-price]');
      var compare = section.querySelector('[data-vg-compare]');
      if (price) price.textContent = money(Number(opt.getAttribute('data-price')));
      if (compare) compare.textContent = Number(opt.getAttribute('data-compare')) > Number(opt.getAttribute('data-price')) ? money(Number(opt.getAttribute('data-compare'))) : '';
      section.querySelectorAll('[data-vg-atc]').forEach(function (b) {
        var available = opt.getAttribute('data-available') === 'true';
        b.disabled = !available;
      });
    });
  });

  /* ---------- Bundle tiers ---------- */
  document.querySelectorAll('[data-vg-bundles]').forEach(function (bundle) {
    var section = bundle.closest('[data-vg-product]');
    var idInput = section && section.querySelector('[data-vg-bundle-id]');
    var status = section && section.querySelector('[data-vg-sync-status]');
    var errorEl = section && section.querySelector('[data-vg-error]');

    function bundleItems(tier) {
      var packs = Number(tier.querySelector('[data-vg-tier-qty]').textContent) || 1;
      var pack = tier.getAttribute('data-variant');
      var items = [{ id: Number(pack), quantity: packs, properties: { _vg_bundle: '1' } }];
      var qtyById = {}, giftIds = {};
      tier.querySelectorAll('[data-vg-gift]').forEach(function (g) { var id = g.getAttribute('data-vg-gift'); giftIds[id] = true; qtyById[id] = (qtyById[id] || 0) + 1; });
      tier.querySelectorAll('[data-vg-addon]:checked').forEach(function (a) {
        var id = a.getAttribute('data-vg-addon');
        var n = Number(a.closest('.vg-tier__row').querySelector('[data-vg-addon-qty]').textContent) || 1;
        qtyById[id] = (qtyById[id] || 0) + n;
      });
      Object.keys(qtyById).forEach(function (id) {
        // A gift that is also a ticked add-on is split: one free unit tagged as the gift, the rest as plain add-ons.
        if (giftIds[id]) {
          items.push({ id: Number(id), quantity: 1, properties: { _vg_bundle: '1', _vg_gift_for: pack } });
          if (qtyById[id] > 1) items.push({ id: Number(id), quantity: qtyById[id] - 1, properties: { _vg_bundle: '1' } });
        } else {
          items.push({ id: Number(id), quantity: qtyById[id], properties: { _vg_bundle: '1' } });
        }
      });
      return items;
    }

    // Replace whatever the picker put in the cart before with the current selection. Last call wins.
    var syncSeq = 0, inFlight = Promise.resolve();
    function sync() {
      var seq = ++syncSeq;
      var tier = bundle.querySelector('.vg-tier.is-selected');
      if (!tier) return Promise.resolve();
      inFlight = inFlight.then(function () {
        if (seq !== syncSeq) return;
        return clearPreviousBundle()
          .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: bundleItems(tier) }) }); })
          .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); })
          .then(function () { return refreshCart(); })
          .then(function () {
            if (seq !== syncSeq) return;
            if (errorEl) errorEl.hidden = true;
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || 'Could not update your cart. Please try again.'; errorEl.hidden = false; }
          });
      });
      return inFlight;
    }
    bundle._vgSync = sync;
    function summary() {
      var tier = bundle.querySelector('.vg-tier.is-selected');
      if (!tier || !status) return;
      var packs = Number(tier.querySelector('[data-vg-tier-qty]').textContent) || 1;
      var total = Number(tier.getAttribute('data-price')) * packs;
      var addons = 0;
      tier.querySelectorAll('[data-vg-addon]:checked').forEach(function (a) {
        var row = a.closest('.vg-tier__row');
        addons += Number(row.querySelector('[data-vg-unit]').getAttribute('data-vg-unit')) * (Number(row.querySelector('[data-vg-addon-qty]').textContent) || 1);
      });
      var gifts = [].map.call(tier.querySelectorAll('[data-vg-gift]'), function (g) { return g.textContent.replace(/^\s*\+\s*FREE\s*/i, '').replace(/\$[\d.,]+\s*$/, '').trim(); });
      var name = tier.querySelector('.vg-tier__title').textContent.trim() + (packs > 1 ? ' ×' + packs : '');
      status.hidden = false;
      status.textContent = 'Selected: ' + name + ' · ' + money(total + addons) + (gifts.length ? ' · includes free ' + gifts.join(' + ') : '');
      section.querySelectorAll('[data-vg-btn-price]').forEach(function (el) { el.textContent = '· ' + money(total + addons); });
    }
    function scheduleSync() { summary(); }
    summary();
    function select(tier) {
      bundle.querySelectorAll('.vg-tier').forEach(function (t) {
        var on = t === tier;
        t.classList.toggle('is-selected', on);
        var radio = t.querySelector('input[type=radio]');
        if (radio) radio.checked = on;
      });
      if (idInput) idInput.value = tier.getAttribute('data-variant');
      // The headline price stays on the single-unit price; the selected bundle's total lives on the button.
    }
    function tierPrice(tier) {
      var n = Number(tier.querySelector('[data-vg-tier-qty]').textContent) || 1;
      tier.querySelector('.vg-tier__price').textContent = money(Number(tier.getAttribute('data-price')) * n);
      var cmp = tier.querySelector('.vg-tier__compare');
      if (cmp) cmp.textContent = money(Number(tier.getAttribute('data-compare')) * n);
    }
    bundle.addEventListener('click', function (e) {
      var tier = e.target.closest('.vg-tier');
      if (!tier) return;
      var step = e.target.closest('[data-vg-inc], [data-vg-dec]');
      if (step) {
        e.preventDefault();
        e.stopPropagation();
        var out = step.parentNode.querySelector('[data-vg-tier-qty], [data-vg-addon-qty]');
        var next = Math.min(20, Math.max(1, (Number(out.textContent) || 1) + (step.hasAttribute('data-vg-inc') ? 1 : -1)));
        out.textContent = next;
        if (out.hasAttribute('data-vg-tier-qty')) tierPrice(tier);
        var unit = step.closest('.vg-tier__row') && step.closest('.vg-tier__row').querySelector('[data-vg-unit]');
        if (unit) unit.textContent = money(Number(unit.getAttribute('data-vg-unit')) * next);
        if (!tier.classList.contains('is-selected')) select(tier);
        scheduleSync();
        return;
      }
      var addonRow = e.target.closest('.vg-tier__row--addon');
      if (addonRow) {
        e.preventDefault();
        var box = addonRow.querySelector('input');
        box.checked = !box.checked;
        addonRow.classList.toggle('is-checked', box.checked);
      }
      if (!tier.classList.contains('is-selected')) select(tier);
      scheduleSync();
    });
  });

  /* ---------- Sticky add to cart ---------- */
  var sticky = document.querySelector('[data-vg-sticky]');
  var mainBtn = document.querySelector('[data-vg-main-atc]');
  if (sticky && mainBtn) {
    // Show once the buy button has scrolled above the top of the screen.
    var stickyTick = false;
    function updateSticky() {
      stickyTick = false;
      var passed = mainBtn.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-visible', passed);
      sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
    }
    function onScroll() { if (!stickyTick) { stickyTick = true; requestAnimationFrame(updateSticky); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateSticky();
    var stickyBtn = sticky.querySelector('[data-vg-sticky-btn]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Delivery estimate (business days) ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  }
  document.querySelectorAll('[data-vg-eta]').forEach(function (el) {
    var min = Number(el.getAttribute('data-min')) || 8;
    var max = Number(el.getAttribute('data-max')) || 15;
    var fmt = { month: 'short', day: 'numeric' };
    var from = addBusinessDays(new Date(), min).toLocaleDateString('en-US', fmt);
    var to = addBusinessDays(new Date(), max).toLocaleDateString('en-US', fmt);
    var out = el.querySelector('[data-vg-eta-range]');
    if (out) out.textContent = from + ' – ' + to;
  });

  /* ---------- One FAQ open at a time within a group ---------- */
  document.querySelectorAll('.vg-accordion').forEach(function (group) {
    group.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        group.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });
})();
